import React from "react";
// import CategoryWhyChooseUs from "../category-components/CategoryWhyChooseUs";
import IndoChineseFeatureSection from "../category-components/IndoChineseFeatureSection";
import IndoChineseProduct from "../category-components/IndoChineseProduct";
import BreadcrumbBanner from "../components/BreadcrumbBanner";
import SeoHelmet from "../Seo/SeoHelmet";
// import IndianStreetChoose from "../category-components/IndianStreetChoose";
import IndoChineseChoose from "../category-components/IndoChineseChoose";

const IndoChinese = () => {
  return (
    <div>
      <SeoHelmet page="indo-chinese" />
      <BreadcrumbBanner
        title="Indian Cuisine"
        backgroundImage="/Images/banner-about.jpg"
      />
      <IndoChineseFeatureSection />
      <IndoChineseProduct />
      <IndoChineseChoose/>
    </div>
  );
};

export default IndoChinese;
